import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { alto, white } from '@parchment/atoms';
const StyledMenu = /*#__PURE__*/styled(components.Menu).withConfig({
  displayName: "Menu__StyledMenu",
  componentId: "sc-10jgbs2-0"
})(["top:calc(100% + 2px);padding-top:8px;transform:translateX(", "px);&::before{content:'';position:absolute;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid ", ";top:0;left:50%;transform:translateX(-50%);}&::after{content:'';position:absolute;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid ", ";top:1px;left:50%;transform:translateX(-50%);}"], props => props.offsetX, alto, white);
export class Menu extends React.Component {
  static get propTypes() {
    return {
      ...components.Menu.propTypes
    };
  }
  static get defaultProps() {
    return {
      ...components.Menu.defaultProps
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      offsetX: 0
    };
    this.menuRef = null;
  }
  componentDidMount() {
    // offset the menu if the menu width is smaller/larger than the select width
    const {
      current
    } = this.props.selectProps.select;
    if (current && this.menuRef) {
      const selectWidth = current.getBoundingClientRect().width;
      const menuWidth = this.menuRef.getBoundingClientRect().width;
      let offsetX = (selectWidth < menuWidth ? selectWidth - menuWidth : menuWidth - selectWidth) / 2;
      if (this.state.offsetX !== offsetX) {
        this.setState({
          offsetX
        });
      }
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(StyledMenu, _extends({}, this.props, {
      innerRef: menuRef => this.menuRef = menuRef,
      offsetX: this.state.offsetX
    }), this.props.children);
  }
}